(ns app.front.view.group.admin.attachment-type-config
  (:require [app.domain.util :as du]
            [app.front.entities :as entities]
            [app.front.ui.action-buttons :as ui-action-buttons]
            [app.front.ui.content-switcher :as ui-cs]
            [app.front.ui.i18n :as ui-i18n]
            [app.front.ui.tag-type-editor :as ui-tag-type-editor]
            [app.front.view.attachment.common :as attachment-common]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.subs :as gas]
            [app.i18n.model :as i18n-model]
            [clojure.string :as str]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))

(defn- attachment-type-item [entity lang]
  {:alphabet (-> entity (attachment-common/attachment-type-label lang) (or "") str/upper-case first)
   :name     (-> entity :attachment-type/names i18n-model/strings-map)
   :id       (:db/id entity)
   :key      (:attachment-type/key entity)})

(rf/reg-sub ::type-items
  :<- [::entities/entities {:entity/type :entity.type/attachment-type}]
  (fn [attachment-types [_ group-id lang kind]]
    (->> attachment-types
         (filter #(= (-> % :attachment-type/authority-group :db/id) group-id))
         (filter #(= kind (:attachment-type/kind %)))
         (sort-by #(attachment-common/attachment-type-label % lang))
         (map #(attachment-type-item % lang)))))

(defn editor-actions [config *selected-attachments save-id {:keys [available-attachments-kw default-attachments save-fn]}]
  (let [tr                            (<sub [::gas/group-tr])
        default-available-attachments (if (some? config)
                                        (->> config available-attachments-kw du/entity-id-set)
                                        default-attachments)
        disabled?                     (= default-available-attachments (get @*selected-attachments save-id))]
    [ui-action-buttons/save-cancel-buttons
     (util/mmap {:on-cancel #(swap! *selected-attachments
                                    (fn [val] (assoc val save-id default-available-attachments)))
                 :on-save   #(save-fn
                               (or config save-id)
                               {available-attachments-kw (get @*selected-attachments save-id)})
                 :size      :small}
                disabled? tr)]))

(defn available-attachments-editor [tr config group-id
                                    {:keys [group-kw kind loading? toggle-disabled?]
                                     :as   params}
                                    *selected-attachments]
  (let [save-id          (or (:db/id config) group-id)
        language         (<sub [::ui-i18n/editor-language ::gas/allowed-locales])
        attachment-types (<sub [::type-items group-id language kind])]
    [:<>
     [ui-tag-type-editor/editor
      (util/mmap {:values              attachment-types
                  :selected?           (fn [{:keys [id]}]
                                         (contains? (get @*selected-attachments save-id) id))
                  :toggle-disabled?    (or toggle-disabled? (constantly false))
                  :on-toggle           (fn [checked? {:keys [id]}]
                                         (swap! *selected-attachments update save-id (if checked? conj disj) id))
                  :on-end-edit         (fn [{:keys [id name] :as item}]
                                         (let [language (ui-i18n/get-actual-language-to-edit name language)]
                                           (>evt [::gas/end-edit-attachment-type id language item])))
                  :edit-disabled?      (comp (<sub [::gas/types-in-use]) :id)
                  :group-by-fn         (when (> (count attachment-types) 5) :alphabet)
                  :name-attr           :name
                  :on-create           #(>evt [::gas/store-new-type
                                               save-id
                                               (if (some? config) (->> config group-kw :db/id) group-id)
                                               (assoc % :kind kind)])
                  :on-delete           #(>evt [::gas/remove-attachment-type (:id %)])
                  :create-in-progress? (<sub [::gas/create-type-in-progress? save-id])
                  :loading?            loading?
                  :tag-type-name       (tr [:attachment-type-editor/attachment-type])
                  :remove-confirmation (tr [:attachment-type-editor/remove-confirmation])}
                 tr)]
     [editor-actions config *selected-attachments save-id params]]))


(defn attachment-editors [tr root-configs group-id {:keys [available-attachments-kw target-kw] :as params}]
  (r/with-let [*selected             (r/atom (-> root-configs first :db/id))
               *selected-attachments (r/atom (reduce (fn [acc item]
                                                       (assoc acc
                                                              (:db/id item)
                                                              (or (->> item available-attachments-kw du/entity-id-set) #{})))
                                                     {}
                                                     root-configs))]
    [acommon/admin-config-form
     [ui-cs/content-switcher {:items     (map :db/id root-configs)
                              :val->str  (fn [val]
                                           (let [config (->> root-configs
                                                             (filter #(= (:db/id %) val))
                                                             first)]
                                             (tr [(target-kw config)])))
                              :current   @*selected
                              :on-change #(reset! *selected %)
                              :class     "mb-4"}]
     [available-attachments-editor
      tr
      (->> root-configs
           (filter #(= (:db/id %) @*selected))
           first)
      group-id
      params
      *selected-attachments]]))
